/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse Code Translator — Text ↔ Morse | Toolverse`)
};

const es_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traductor de Código Morse — Texto ↔ Morse | Toolverse`)
};

const de_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morsecode-Übersetzer — Text ↔ Morse | Toolverse`)
};

const nl_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse Code Translator — Tekst ↔ Morse | Toolverse`)
};

const fr_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducteur de Code Morse — Texte ↔ Morse | Toolverse`)
};

const it_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduttore di Codice Morse — Testo ↔ Morse | Toolverse`)
};

const pt_br2_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradutor de Código Morse — Text ↔ Morse | Toolverse`)
};

const pt_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradutor de Código Morse — Texto ↔ Morse | Toolverse`)
};

const ja_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モールス信号翻訳ツール — テキスト ↔ モールス | Toolverse`)
};

const zh_mc_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔斯电码翻译器——文本 ↔ 摩尔斯电码 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_meta_title", locale)
	if (locale === "en") return en_mc_meta_title(inputs)
	if (locale === "es") return es_mc_meta_title(inputs)
	if (locale === "de") return de_mc_meta_title(inputs)
	if (locale === "nl") return nl_mc_meta_title(inputs)
	if (locale === "fr") return fr_mc_meta_title(inputs)
	if (locale === "it") return it_mc_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_mc_meta_title(inputs)
	if (locale === "pt") return pt_mc_meta_title(inputs)
	if (locale === "ja") return ja_mc_meta_title(inputs)
	return zh_mc_meta_title(inputs)
};